const config = {
  accepts:
    "image/jpg,image/jpeg,image/png,image/bmp,image/tif,image/tiff,application/dicom,.dcm",
  apiName: "api8a82ed48",
  apiUrl: "https://api.epona-intellect-engine.com",
  apiUrl2: "http://localhost:8040",
  billingUrl: "https://epona-billing-platform.com"
};
export default config;
